<template>
  <a-modal
    v-model:visible="isOpen"
    title="增加代理"
    @cancel="handleCancel"
    @ok="handleAddAgent"
    okText="增加"
    cancelText="取消"
    width="800px"
    :maskClosable="false"
  >

  <div class="account-list">
    <h3>代理IP类型</h3>
    <a-form-item>
      <a-select
        v-model:value="formState.ipkind"
        placeholder="请选择代理IP类型"
        style="width: 98%"
        @change="handleSenderChange"
        @focus="handleSenderFocus"
      >
        <a-select-option
          v-for="sender in senders"
          :key="sender.ipKind"
          :value="sender.ipKind"
        >
          {{ sender.strIPKind }}
        </a-select-option>
      </a-select>
    </a-form-item>
  </div>


  <div class="receiver-list">
    <h3>IP或者域名</h3>
    <!-- 添加指定账号输入框 -->
    <div class="specify-account">
      <a-input-group compact>
        <a-input
          v-model:value="formState.ip"
          placeholder="请输入IP或者域名"
          style="width: 98%"
        />
      </a-input-group>
    </div>
  </div> 

  <div class="receiver-list">
    <h3>端口</h3>
    <!-- 添加指定账号输入框 -->
    <div class="specify-account">
      <a-input-group compact>
        <a-input
          v-model:value="formState.port"
          placeholder="请输入端口"
          style="width: 98%"
        />
      </a-input-group>
    </div>
  </div> 

  <div class="receiver-list" v-if="usernameVisible">
    <h3>用户名</h3>
    <!-- 添加指定账号输入框 -->
    <div class="specify-account">
      <a-input-group compact>
        <a-input
          v-model:value="formState.username"
          placeholder="请输入用户名"
          style="width: 98%"
        />
      </a-input-group>
    </div>
  </div>

  <div class="receiver-list" v-if="passwordVisible">
    <h3>密码</h3>
    <!-- 添加指定账号输入框 -->
    <div class="specify-account">
      <a-input-group compact>
        <a-input
          v-model:value="formState.password"
          placeholder="请输入密码"
          style="width: 98%"
        />
      </a-input-group>
    </div>
  </div>

  <div class="receiver-list" v-if="secretKeyVisible">
    <h3>密钥</h3>
    <!-- 添加指定账号输入框 -->
    <div class="specify-account">
      <a-input-group compact>
        <a-input
          v-model:value="formState.secret_key"
          placeholder="请输入密钥"
          style="width: 98%"
        />
      </a-input-group>
    </div>
  </div>
   
  </a-modal>

 

</template>

<script lang="ts" setup>
import {
  ref,
  computed,
  watch,
  onMounted,
  nextTick,
  onBeforeUnmount,
  h,
  reactive,
} from "vue";
import { TelegramClient } from "@/websocket/Client";
import { message } from "ant-design-vue";
const client = TelegramClient.getInstance();
//ip代理类型
interface agentKind {
  ipKind: string; // ipKind
  strIPKind: string; // strIPKind
}
// 添加新的 ref
const addTaskModalVisible = ref(false);
const confirmLoading = ref(false);
const ip = ref('');
const usernameVisible = ref(true);
const passwordVisible = ref(true);
const secretKeyVisible = ref(false);

const senders = ref<agentKind[]>([]);
const props = defineProps<{
  visible: boolean;
}>();

const emit = defineEmits<{
  (e: "update:visible", visible: boolean): void;
  (e: "refreshAgents", data: any[]): void;
  (e: "success"): void;
}>();


// 使用计算属性处理 visible 状态
const isOpen = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value),
});


 
const formState = reactive({
  ipkind: "",
  ip: "",
  port: "",
  username: "",
  password: "",
  secret_key:"",
});


// 处理取消添加任务
const handleAddAgentCancel = () => {
  addTaskModalVisible.value = false;
 
  console.log("handleAddAgentCancel");

};

// 加发送者选择处理函数
const handleSenderChange = (value: string) => {
  //formState.sender = value;
  console.log("handleSenderChange"+value);
  let proxy_type = parseInt(value);
  if(proxy_type == 3)
  {
     usernameVisible.value = false;
     passwordVisible.value = false;
     secretKeyVisible.value = true;
  }
  else
  {
     usernameVisible.value = true;
     passwordVisible.value = true;
     secretKeyVisible.value = false;
  }

};

// 修改发送者选择框的点击事件
const handleSenderFocus = async () => {
  if (senders.value.length === 0) {
     
  }
};

 
onMounted(async () => {

  var agentDataList:agentKind[] = [];
  var strKindArr = ["SOCKS5","HTTP","MTPROTO"];
  for (let i = 0; i < 3; i++) {
     agentDataList[i] = {ipKind:""+(i+1),strIPKind:strKindArr[i]};
  }

  senders.value = agentDataList;

  console.log("onMounted");
 
 

 }
);
 
// 修改取消操作
const handleCancel = () => {
  emit("update:visible", false);
  formState.ipkind = "";
  formState.ip = "";
  formState.port = "";
  formState.username = "";
  formState.password = "";
  formState.secret_key = "";
};


 
// 处理新增任务
const handleAddAgent = async () => {

  console.log("handleAddAgent");

  if (!formState.ipkind) {
    message.warning("请选择代理IP类型");
    return;
  }
  let proxy_type = parseInt(formState.ipkind);
  if (!formState.ip) {
    message.warning("IP或者域名不能未空");
    return;
  }
  if (!formState.port) {
    message.warning("端口不能未空");
    return;
  }
  if(proxy_type < 3)
  {
    if (!formState.username) {
      message.warning("用户名不能未空");
      return;
    }
    if (!formState.password) {
      message.warning("密码不能未空");
      return;
    }

  }
  else
  {

    if (!formState.secret_key) {
      message.warning("密钥不能未空");
      return;
    }

  }

  let port = parseInt(formState.port);
  const agentData = {
      proxy_type:proxy_type,
      address:formState.ip,
      port:port,
      username:formState.username,
      password:formState.password,
      secret_key:formState.secret_key,
    };

  const response = await client.createAgent(agentData);
  if (response.code === 1) {
     emit("refreshAgents", response.list);
     message.warning("提交成功");
     handleCancel();
  }  
  else
  {
    message.error(response.msg);
  }
 
};  

 
 
</script>

<style scoped>
.form-container {
  outline: none;
  padding: 10px;
}

.receiver-list {
  flex: 1.0;  /* 适当调整接收账号区域的宽度 */
  padding: 10px;
  border-radius: 4px;
}

.account-list {
  flex: 1.0;  /* 适当调整接收账号区域的宽度 */
  padding: 10px;
  border-radius: 4px;
}

</style>
